<template>
  <!-- 会配合路由模块，根据不同的路由，显示不同的虚拟页面 -->
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped lang="scss">
</style>
